// Role gating helpers for the Field Activities workspace.
//
// Matches the backend activity rules: the "manager" family owns the workflow
// (create/publish/cancel/close/review/approve/reject). Agronomists are included
// as managers (matching the backend MANAGER_ROLES in activityRules.js). Field
// facilitators can view their assigned work and reports but are not shown the
// management actions in the UI.

const MANAGER_ROLES = [
    'super_admin',
    'project_manager',
    'tenant_admin',
    'business_manager',
    'field_manager',
    'agronomist_advisor',
    'agronomist',
];

export const normalizeRole = (role?: string): string => String(role || '').toLowerCase();

export const isActivityManager = (role?: string): boolean =>
    MANAGER_ROLES.includes(normalizeRole(role));

export const canManageAssignments = (role?: string): boolean => isActivityManager(role);

export const canReviewReports = (role?: string): boolean => isActivityManager(role);

export const canCreateAssignments = (role?: string): boolean => isActivityManager(role);

export const canExport = (role?: string): boolean => isActivityManager(role);
